import React, { createContext, useEffect, useContext } from 'react';
import { evaluateRunningInApp } from '../appConstants/appConstants.js';
import ipcService, { isConnected } from './ipcService.js';
import { errorIfVerbose, enableVerboseLogging, disableVerboseLogging } from './loggingControl.js';

var IpcContext = createContext(undefined);
var IpcProvider = function (_a) {
    var children = _a.children, _b = _a.verbose, verbose = _b === void 0 ? false : _b, _c = _a.autoConnect, autoConnect = _c === void 0 ? false : _c;
    var mobile = evaluateRunningInApp();
    // Handle verbose logging
    useEffect(function () {
        if (verbose) {
            enableVerboseLogging();
        }
        else {
            disableVerboseLogging();
        }
    }, [verbose]);
    // Handle auto-connection
    useEffect(function () {
        if (mobile && !isConnected() && autoConnect) {
            ipcService.connect();
            return function () {
                if (ipcService.isConnected()) {
                    ipcService.endSession().catch(function (error) {
                        errorIfVerbose('Error ending IPC session:', error);
                    });
                }
            };
        }
        return function () { };
    }, [mobile, autoConnect]);
    var contextValue = {
        isConnected: function () { return ipcService.isConnected(); },
        connect: function () { return ipcService.connect(); },
        ping: function () { return ipcService.ping(); },
        beginSession: function (showNativeHeader) { return ipcService.beginSession(showNativeHeader); },
        endSession: function (route) { return ipcService.endSession(route); },
        generateError: function (error) { return ipcService.generateError(error); },
        getAppFeatureManifest: function () { return ipcService.getAppFeatureManifest(); },
        getDigSigAvailability: function () { return ipcService.getDigSigAvailability(); },
        getDigSigSignature: function (data) { return ipcService.getDigSigSignature(data); },
    };
    return React.createElement(IpcContext.Provider, { value: contextValue }, children);
};
var useIpc = function () {
    var context = useContext(IpcContext);
    if (context === undefined) {
        throw new Error('useIpc must be used within an IpcProvider');
    }
    return context;
};

export { IpcProvider, useIpc };
